/* DERWAL Razor Holder (with drip tray): 3D animation for the product page stage, also used by the preview page.
   Shows the rubber feet and logo, the size, the 79 mm between the outer edges of the supports, and which razors fit. */
(function () {
  var stage = document.getElementById('stage');
  if (!stage || !stage.getAttribute('data-model')) return;
  var cv = document.getElementById('cv');
  var statusEl = document.getElementById('status');
  var labelEl = document.getElementById('colorLabel');
  var captionEl = document.getElementById('caption');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NL = /^nl/i.test(document.documentElement.lang || '');
  function L(en, nl) { return NL ? nl : en; }
  if (!window.THREE) { statusEl.textContent = L('3D could not be loaded in this browser.', '3D kon niet worden geladen in deze browser.'); return; }

  if (!document.getElementById('dw-dims-style')) {
    var st = document.createElement('style'); st.id = 'dw-dims-style';
    st.textContent = '.stage .dims{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}' +
      '.stage .dim-tag{position:absolute;left:0;top:0;pointer-events:none;white-space:nowrap;padding:3px 8px;font-family:Montserrat,"Helvetica Neue",Arial,sans-serif;font-weight:600;font-size:clamp(10px,1.15vw,13px);letter-spacing:.08em;color:#15171B;background:rgba(247,247,245,.82);border:1px solid rgba(20,21,24,.14);opacity:0}';
    document.head.appendChild(st);
  }
  var SVGNS = 'http://www.w3.org/2000/svg';
  var dimSvg = document.getElementById('dims'), dimTagsEl = document.getElementById('dimTags');
  var coAnchor = document.getElementById('co');
  if (!dimSvg) { dimSvg = document.createElementNS(SVGNS, 'svg'); dimSvg.setAttribute('class', 'dims'); dimSvg.id = 'dims'; dimSvg.setAttribute('aria-hidden', 'true'); stage.insertBefore(dimSvg, coAnchor); }
  if (!dimTagsEl) { dimTagsEl = document.createElement('div'); dimTagsEl.id = 'dimTags'; stage.insertBefore(dimTagsEl, coAnchor); }

  var COLORS = [{ name: 'Black', hex: 0x1B1C1E }, { name: 'Green', hex: 0x1F4A40 }, { name: 'Blue', hex: 0x22385A }];
  function lin(hex) { return new THREE.Color(hex).convertSRGBToLinear(); }

  var renderer;
  try { renderer = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: true }); }
  catch (e) { statusEl.textContent = L('3D is not supported in this browser.', '3D wordt niet ondersteund in deze browser.'); return; }
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.82;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  var scene = new THREE.Scene();
  var pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
  var camera = new THREE.PerspectiveCamera(26, 16 / 9, 10, 3000);

  var key = new THREE.DirectionalLight(0xffffff, 1.25);
  key.position.set(-120, 240, 160); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.left = -170; key.shadow.camera.right = 170; key.shadow.camera.top = 170; key.shadow.camera.bottom = -170;
  key.shadow.camera.near = 10; key.shadow.camera.far = 800; key.shadow.radius = 6; key.shadow.bias = -0.0004;
  scene.add(key);
  var rim = new THREE.DirectionalLight(0xffffff, 0.6); rim.position.set(160, 120, -180); scene.add(rim);
  scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d8d4, 0.22));
  var ground = new THREE.Mesh(new THREE.PlaneGeometry(3000, 3000), new THREE.ShadowMaterial({ opacity: 0.18 }));
  ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

  // Model frame (mm), measured from the part: 125 long (x) \u00d7 60 wide (z) \u00d7 29.4 high, bottom of the body on y = 0.
  // Tray floor y = 3, rim y = 7. Two cradles (R 7): the high one x -39.1 \u2026 -24.0 (bottom y 23.7),
  // the low one x 25.2 \u2026 40.1 (bottom y 17.0). Their outer edges are 79 mm apart. Four \u00d8 8.3 recesses for rubber feet.
  var FOOT = 1.4;   // rubber feet stick out below the body
  var MID = 15;
  var turn = new THREE.Group(); scene.add(turn);
  var flip = new THREE.Group(); flip.position.y = MID + FOOT; turn.add(flip);
  var model = new THREE.Group(); model.visible = false; model.position.y = -MID; flip.add(model);
  var bodyMat = new THREE.MeshStandardMaterial({ color: lin(COLORS[0].hex), roughness: 0.78, metalness: 0, envMapIntensity: 0.45 });
  var logoMat = new THREE.MeshStandardMaterial({ color: lin(0xEDEDEA), roughness: 0.6, envMapIntensity: 0.6 });
  var rubberMat = new THREE.MeshStandardMaterial({ color: lin(0x111112), roughness: 0.9, metalness: 0, envMapIntensity: 0.3, emissive: 0x000000 });
  var footHl = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 });
  var chrome = new THREE.MeshStandardMaterial({ color: lin(0xD9DDE2), metalness: 1, roughness: 0.18, envMapIntensity: 1.3 });
  var bladeMat = new THREE.MeshStandardMaterial({ color: lin(0xC9CDD3), metalness: 1, roughness: 0.22, envMapIntensity: 1.2 });
  var waterMat = new THREE.MeshStandardMaterial({ color: lin(0xBFD7EA), metalness: 0, roughness: 0.05, transparent: true, opacity: 0.75, envMapIntensity: 1.4 });

  // rubber feet in the four recesses
  [[-50, -18], [-50, 18], [50, -18], [50, 18]].forEach(function (q) {
    // rounded (dome) bumper, sitting in its 0.6 mm recess
    var f = new THREE.Mesh(new THREE.SphereGeometry(4, 28, 14, 0, Math.PI * 2, 0, Math.PI / 2), rubberMat);
    f.rotation.x = Math.PI; f.scale.y = (FOOT + 0.6) / 4; f.position.set(q[0], 0.6, q[1]); f.castShadow = true; model.add(f);
    var ringPts = []; for (var a = 0; a <= 48; a++) ringPts.push(new THREE.Vector3(q[0] + 5.2 * Math.cos(a / 48 * Math.PI * 2), -0.05, q[1] + 5.2 * Math.sin(a / 48 * Math.PI * 2)));
    var rl = new THREE.Line(new THREE.BufferGeometry().setFromPoints(ringPts), footHl); rl.renderOrder = 6; model.add(rl);
  });

  function smooth(geo) {
    var U = THREE.BufferGeometryUtils;
    if (U && U.toCreasedNormals) return U.toCreasedNormals(geo, 0.6);
    geo.computeVertexNormals(); return geo;
  }

  // ----- the razors (built here; not part of the CAD file) -----
  // Head local frame: x across (42), z front to back (22), y along the razor towards the handle.
  function yb(z) { return -1.6 * (1 - Math.pow(z / 11.2, 2)); }
  function arc(z0, z1, n, f) { var a = []; for (var i = 0; i <= n; i++) { var z = z0 + (z1 - z0) * i / n; a.push([z, f(z)]); } return a; }
  function headPart(pts, width, cornerR, steps) {
    var sh = new THREE.Shape(pts.map(function (p) { return new THREE.Vector2(p[0], p[1]); }));
    var geo = new THREE.ExtrudeGeometry(sh, { depth: width, steps: steps, bevelEnabled: false, curveSegments: 1 });
    geo.rotateY(Math.PI / 2); geo.translate(-width / 2, 0, 0);
    var pos = geo.attributes.position, half = width / 2, v;
    for (var i = 0; i < pos.count; i++) {
      var x = pos.getX(i), d = Math.abs(x) - (half - cornerR);
      if (d > 0) { v = Math.sqrt(Math.max(0.04, 1 - Math.pow(d / cornerR, 2))); pos.setZ(i, pos.getZ(i) * (0.55 + 0.45 * v)); pos.setY(i, pos.getY(i) * (0.7 + 0.3 * v)); }
    }
    return smooth(geo);
  }
  var capPts = arc(-10.2, 10.2, 40, function (z) { return yb(z) - 0.75 - 3.0 * Math.pow(Math.max(0, 1 - Math.pow(z / 10.2, 2)), 0.35); })
    .concat(arc(10.2, -10.2, 24, function (z) { return yb(z) - 0.04; }));
  var bladePts = arc(-11.2, 11.2, 30, function (z) { return yb(z); }).concat(arc(11.2, -11.2, 30, function (z) { return yb(z) + 0.1; }));
  var platePts = arc(-9.0, 9.0, 24, function (z) { return yb(z) + 0.14; })
    .concat([[9.4, 0.9]], arc(9.4, -9.4, 30, function (z) { return 1.5 + 2.3 * Math.pow(Math.max(0, 1 - Math.pow(z / 9.4, 2)), 1.5); }), [[-9.4, 0.9]]);
  var HEAD_LEN = 9.2;   // from the top of the cap to where the handle starts
  var headGeos = null;
  function makeHead() {
    if (!headGeos) headGeos = [headPart(capPts, 43.4, 1.0, 44), headPart(bladePts, 43, 0.01, 4), headPart(platePts, 42, 0.8, 36)];
    var head = new THREE.Group();
    head.add(new THREE.Mesh(headGeos[0], chrome), new THREE.Mesh(headGeos[1], bladeMat), new THREE.Mesh(headGeos[2], chrome));
    [-1, 1].forEach(function (sd) {
      var bar = new THREE.Mesh(new THREE.CylinderGeometry(0.65, 0.65, 41, 20), chrome); bar.rotation.z = Math.PI / 2; bar.position.set(0, 1.25, sd * 10.0); head.add(bar);
    });
    head.rotation.y = Math.PI / 2;   // the 42 mm width lies across the tray, so the head stays clear of the floor
    return head;
  }
  // texture for a handle: cross-hatched knurl or plain rings over a band (fractions of the handle length, butt = 0)
  function handleTexture(kind, from, to) {
    var c = document.createElement('canvas'); c.width = 256; c.height = 1024;
    var g = c.getContext('2d'); g.fillStyle = '#ffffff'; g.fillRect(0, 0, 256, 1024);
    var y0 = (1 - to) * 1024, y1 = (1 - from) * 1024;
    g.save(); g.beginPath(); g.rect(0, y0, 256, y1 - y0); g.clip();
    g.strokeStyle = 'rgba(70,74,80,0.8)';
    if (kind === 'knurl') { g.lineWidth = 3; for (var d = -1024; d < 1280; d += 22) { g.beginPath(); g.moveTo(d, 0); g.lineTo(d + 256, 1024); g.stroke(); g.beginPath(); g.moveTo(d + 256, 0); g.lineTo(d, 1024); g.stroke(); } }
    else { g.lineWidth = 6; for (var y = y0; y < y1; y += 26) { g.beginPath(); g.moveTo(0, y); g.lineTo(256, y); g.stroke(); } }
    g.restore();
    var t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; t.anisotropy = 8; return t;
  }
  // a razor: total length (top of cap to end of handle) and handle radius; group's +y runs from the head to the butt
  function makeRazor(spec) {
    var g = new THREE.Group(), Lh = spec.len - HEAD_LEN, r = spec.r;
    g.add(makeHead());
    var prof = [];
    function P(rr, y) { prof.push(new THREE.Vector2(rr, y)); }
    P(0, 0); P(r - 1.6, 0); P(r - 0.6, 0.3); P(r - 0.1, 1.2); P(r, 2.2); P(r, Lh * 0.92); P(r - 0.35, Lh * 0.95); P(r - 0.2, Lh - 1.6); P(r + 0.3, Lh - 1.0); P(r * 0.8, Lh); P(0, Lh);
    var geo = new THREE.LatheGeometry(prof, 64), pos = geo.attributes.position, uv = geo.attributes.uv;
    for (var i = 0; i < pos.count; i++) uv.setY(i, pos.getY(i) / Lh);   // v along the length, so the pattern band sits where it should
    var mat = (spec.alu ? new THREE.MeshStandardMaterial({ color: lin(spec.alu), metalness: 0.55, roughness: 0.42, envMapIntensity: 0.9 }) : chrome.clone());
    mat.map = handleTexture(spec.alu ? 'rings' : 'knurl', spec.band[0], spec.band[1]);
    var handle = new THREE.Mesh(geo, mat);
    handle.rotation.z = Math.PI; handle.position.y = 3.8 + Lh;   // neck on the head, butt away from it
    g.add(handle);
    g.traverse(function (o) { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } });
    return g;
  }
  // the razors shown, with their total length (mm) and handle diameter
  var RAZORS = [
    { name: 'Henson AL13', len: 96, r: 6.0, alu: 0x8C9096, band: [0.1, 0.9] },
    { name: 'Merkur 34C', len: 83, r: 5.85, band: [0.08, 0.85] },
    { name: 'Parker 99R', len: 109, r: 6.5, band: [0.1, 0.8] },
    { name: 'King C. Gillette', len: 101, r: 5.5, band: [0.12, 0.55] }
  ];
  var razors = [];

  // resting pose: the head hangs past the low cradle, over the tray; the handle lies in both cradles
  var HI = { x: -31.7, y: 23.73 }, LO = { x: 32.5, y: 16.95 }, SLOPE = (LO.y - HI.y) / (LO.x - HI.x);
  var NECK_X = -41.5;   // the head sits just past the high cradle (head up, so the razor cannot slide off)
  var DIR = new THREE.Vector2(LO.x - HI.x, LO.y - HI.y).normalize();   // from the head towards the butt (downhill)
  var ROT = Math.atan2(-DIR.x, DIR.y);
  function restPos(r) {
    var yAxis = HI.y + r + SLOPE * (NECK_X - HI.x);
    return new THREE.Vector3(NECK_X - DIR.x * 3.8, yAxis - DIR.y * 3.8, 0);
  }
  function endX(spec) { return NECK_X + DIR.x * (spec.len - HEAD_LEN); }

  // water drops falling from the head into the tray
  var drops = [];
  for (var di = 0; di < 3; di++) {
    var dm = new THREE.Mesh(new THREE.SphereGeometry(0.9, 16, 12), waterMat); dm.scale.y = 1.35; dm.visible = false; model.add(dm);
    var ring = new THREE.Mesh(new THREE.RingGeometry(0.6, 1.1, 32), new THREE.MeshBasicMaterial({ color: 0xBFD7EA, transparent: true, opacity: 0, side: THREE.DoubleSide }));
    ring.rotation.x = -Math.PI / 2; ring.visible = false; model.add(ring);
    drops.push({ m: dm, ring: ring });
  }

  // ---------- timeline ----------
  var BASE = -0.42, SHIFT = 2.6, CYCLE = 34.0 + SHIFT;
  var colorIdx = 0, fromC = lin(COLORS[0].hex), toC = lin(COLORS[0].hex), mixK = 1, cycleOn = !reduce;
  var t = 0, last = null, loaded = false, lastCyc = -1;
  var userYaw = 0, dragging = false, dragX = 0, idle = 0;
  function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function clamp(x) { return Math.max(0, Math.min(1, x)); }
  function seg(x, a, b) { return clamp((x - a) / (b - a)); }

  function setColor(i, instant) {
    colorIdx = i; fromC = bodyMat.color.clone(); toC = lin(COLORS[i].hex); mixK = instant ? 1 : 0;
    if (instant) bodyMat.color.copy(toC);
    var sw = document.querySelector('#swatches button[data-c="' + i + '"]');
    if (labelEl) labelEl.textContent = (sw && sw.getAttribute('data-name')) || COLORS[i].name;
    document.querySelectorAll('#swatches button').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.c === i)); });
  }
  var lastCap = null;
  function caption(txt) { if (captionEl && txt !== lastCap) { lastCap = txt; captionEl.textContent = txt; } }

  // ----- dimension lines -----
  function V(x, y, z) { return new THREE.Vector3(x, y, z); }
  var DIMS = {
    outer: [
      { a: V(-62.5, 0, 30), b: V(62.5, 0, 30), o: V(0, 0, 1), off: 14, text: '125 mm' },
      { a: V(62.5, 0, 30), b: V(62.5, 0, -30), o: V(1, 0, 0), off: 12, text: '60 mm' }
    ],
    supports: [
      { a: V(-39.1, 24.4, 0), b: V(40.1, 16.0, 0), o: V(0, 1, 0), off: 22, text: L('79 mm, outer edge to outer edge', '79 mm, buitenkant tot buitenkant') }
    ]
  };
  var dimEls = [];
  Object.keys(DIMS).forEach(function (grp) {
    DIMS[grp].forEach(function (d) {
      var g = document.createElementNS(SVGNS, 'g'); g.setAttribute('stroke', '#141518'); g.setAttribute('stroke-width', '1.2'); g.style.opacity = 0;
      var ls = []; for (var i = 0; i < 5; i++) { var l = document.createElementNS(SVGNS, 'line'); g.appendChild(l); ls.push(l); }
      ls[1].setAttribute('stroke-dasharray', '3 3'); ls[2].setAttribute('stroke-dasharray', '3 3'); ls[1].setAttribute('stroke-width', '0.8'); ls[2].setAttribute('stroke-width', '0.8');
      dimSvg.appendChild(g);
      var tag = document.createElement('div'); tag.className = 'dim-tag'; tag.textContent = d.text; dimTagsEl.appendChild(tag);
      dimEls.push({ grp: grp, d: d, g: g, ls: ls, tag: tag });
    });
  });
  var pv = new THREE.Vector3();
  function scr(p, r) { pv.copy(p); model.localToWorld(pv); pv.project(camera); return [(pv.x + 1) / 2 * r.width, (1 - pv.y) / 2 * r.height]; }
  function updateDims(alpha) {
    var r = stage.getBoundingClientRect();
    scene.updateMatrixWorld();
    dimEls.forEach(function (e) {
      var a = alpha[e.grp] || 0;
      e.g.style.opacity = a; e.tag.style.opacity = a;
      if (a <= 0) return;
      var d = e.d, oa = d.a.clone().addScaledVector(d.o, d.off), ob = d.b.clone().addScaledVector(d.o, d.off);
      var A = scr(d.a, r), B = scr(d.b, r), OA = scr(oa, r), OB = scr(ob, r);
      function set(l, p, q) { l.setAttribute('x1', p[0]); l.setAttribute('y1', p[1]); l.setAttribute('x2', q[0]); l.setAttribute('y2', q[1]); }
      set(e.ls[0], OA, OB); set(e.ls[1], A, OA); set(e.ls[2], B, OB);
      var dx = OB[0] - OA[0], dy = OB[1] - OA[1], len = Math.hypot(dx, dy) || 1, nx = -dy / len * 5, ny = dx / len * 5;
      set(e.ls[3], [OA[0] - nx, OA[1] - ny], [OA[0] + nx, OA[1] + ny]);
      set(e.ls[4], [OB[0] - nx, OB[1] - ny], [OB[0] + nx, OB[1] + ny]);
      var mx = (OA[0] + OB[0]) / 2, my = (OA[1] + OB[1]) / 2, ex = mx - (A[0] + B[0]) / 2, ey = my - (A[1] + B[1]) / 2, el = Math.hypot(ex, ey) || 1;
      e.tag.style.transform = 'translate(' + (mx + ex / el * 14) + 'px,' + (my + ey / el * 14) + 'px) translate(-50%,-50%)';
    });
  }
  // the cradles light up while their distance is shown
  var hlMat = new THREE.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0 });
  [[-39.1, -24.0, 23.73], [25.2, 40.1, 16.95]].forEach(function (c) {
    var R = 6.97, cy = c[2] + R, line = [];
    for (var j = 0; j <= 24; j++) { var an = Math.PI + Math.PI * j / 24; line.push(new THREE.Vector3(0, cy + R * Math.sin(an) + 0.15, R * Math.cos(an))); }
    [c[0], c[1]].forEach(function (x) {
      var l = new THREE.Line(new THREE.BufferGeometry().setFromPoints(line.map(function (p) { return new THREE.Vector3(x, p.y + SLOPE * (x - (c[0] + c[1]) / 2), p.z); })), hlMat);
      l.renderOrder = 4; model.add(l);
    });
  });

  // callouts: dot on the model, a line, and a label in a subtle box
  var coSvg = document.getElementById('co'), coLine = document.getElementById('coLine'), coDot = document.getElementById('coDot');
  var coText = document.getElementById('coText'), coTitle = document.getElementById('coTitle'), coSub = document.getElementById('coSub');
  var lastCoKey = '', coV = new THREE.Vector3();
  function updateCallout(d, a) {
    if (!coSvg) return;
    if (!d || a <= 0) { coSvg.style.opacity = 0; coText.style.opacity = 0; return; }
    if (d.title + d.sub !== lastCoKey) { lastCoKey = d.title + d.sub; coTitle.textContent = d.title; coSub.textContent = d.sub; }
    scene.updateMatrixWorld();
    coV.copy(d.at); model.localToWorld(coV); coV.project(camera);
    var r = stage.getBoundingClientRect(), Wd = r.width, Hd = r.height;
    var sx = (coV.x + 1) / 2 * Wd, sy = (1 - coV.y) / 2 * Hd;
    var tw = coText.offsetWidth || 240, th = coText.offsetHeight || 50, gap = d.gap || Math.max(50, Wd * 0.08);
    var right = d.left ? false : sx + gap + tw < Wd - 16;
    var lx = right ? sx + gap : sx - gap, ly = Math.max(th / 2 + 8, sy - Math.min(48, Hd * 0.08));
    coDot.setAttribute('cx', sx); coDot.setAttribute('cy', sy);
    coLine.setAttribute('x1', sx); coLine.setAttribute('y1', sy);
    coLine.setAttribute('x2', lx); coLine.setAttribute('y2', ly);
    coText.style.transform = 'translate(' + (right ? lx : lx - tw) + 'px,' + ly + 'px) translateY(-50%)';
    coSvg.style.opacity = a; coText.style.opacity = a;
  }

  var camDist = 330, camLift = -1;
  function placeCamera(lift) {
    var elev = (22 + 6 * lift) * Math.PI / 180, ty = 14 + 26 * lift;
    var dist = camDist * (1 + 0.15 * lift);
    camera.position.set(0, ty + Math.sin(elev) * dist, Math.cos(elev) * dist);
    camera.lookAt(0, ty, 0);
  }
  function resize() {
    var r = stage.getBoundingClientRect();
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(r.width, r.height, false);
    camera.aspect = r.width / r.height;
    camDist = r.width / r.height < 1.2 ? 520 : 330;
    camera.updateProjectionMatrix();
    placeCamera(Math.max(0, camLift));
  }

  // razor parade: each one is set down, named with its length, and lifted off again; the last one stays for the drips
  var R0 = 10.6, STEP = 3.4;
  function pose(time) {
    var p = { yaw: BASE, flipK: 0, lift: 0, dims: { outer: 0, supports: 0 }, hl: 0, show: [0, 0, 0, 0], co: null, coA: 0, drip: -1, out: 0 };
    if (reduce) { p.show[0] = 1; p.dims.supports = 1; return p; }
    var c0 = time % CYCLE, c = c0 - SHIFT;
    // 0) roll over the long side and pause upside down: the rounded rubber feet light up, then roll back on
    p.flipK = 0.5 * ease(seg(c0, 0.2, 1.5)) + 0.5 * ease(seg(c0, 4.0, 5.2)); p.lift = 0.6 * Math.sin(Math.PI * p.flipK);
    p.feet = Math.min(seg(c0, 1.6, 2.0), 1 - seg(c0, 3.6, 4.0));
    if (c0 >= 1.7 && c0 < 3.9) { p.co = { at: V(50, -FOOT - 0.2, 18), title: L('Rubber feet', 'Rubberen voetjes'), sub: L('Rounded and non-slip, four in total', 'Afgerond en antislip, vier in totaal') }; p.coA = p.feet; }
    if (c0 < SHIFT + 2.6) {
      caption(c0 > 0.5 && c0 < 5.0 ? L('Rubber feet and logo underneath', 'Rubberen voetjes en logo aan de onderkant') : '');
      if (c0 < 5.2) return p;
    }
    // 1) size
    p.dims.outer = Math.min(seg(c, 2.9, 3.4), 1 - seg(c, 5.9, 6.3));
    // 2) the 79 mm between the outer edges of the cradles
    p.dims.supports = Math.min(seg(c, 6.5, 7.0), 1 - seg(c, 29.6, 30.2));
    p.hl = Math.min(seg(c, 6.5, 7.0), 1 - seg(c, 10.0, 10.5));
    // 3) four razors, one after another
    for (var i = 0; i < RAZORS.length; i++) {
      var s0 = R0 + i * STEP, lastOne = i === RAZORS.length - 1;
      var down = ease(seg(c, s0, s0 + 0.8)), up = lastOne ? ease(seg(c, 30.4, 31.4)) : ease(seg(c, s0 + 2.6, s0 + 3.3));
      p.show[i] = down * (1 - up) > 0 ? (up > 0 ? -up : down) : 0;
      if (c >= s0 + 0.8 && c < s0 + 2.6) {
        var spec = RAZORS[i], okSub = spec.len >= 85 ? L('fits', 'past') : L('fits, the end rests on the low cradle', 'past, het einde rust op de lage steun');
        p.co = { at: V(endX(spec) + 2, HI.y + spec.r + SLOPE * (endX(spec) - HI.x) + spec.r, 0), title: spec.name, sub: spec.len + ' mm \u00b7 ' + okSub };
        p.coA = Math.min(seg(c, s0 + 0.8, s0 + 1.1), 1 - seg(c, s0 + 2.3, s0 + 2.6));
      }
    }
    // 4) drips from the head land in the tray
    if (c >= 24.6 && c < 28.4) p.drip = c - 24.6;
    if (c >= 24.8 && c < 28.2) { p.co = { at: V(endX(RAZORS[3]) - 1.5, 4, 8), gap: 28, title: L('Drip tray', 'Lekbak'), sub: L('Drips off the handle into the tray', 'Druppelt van het handvat in de bak') }; p.coA = Math.min(seg(c, 24.8, 25.15), 1 - seg(c, 27.85, 28.2)); }
    // 5) one full turn with the razor in place
    if (c >= 28.4 && c < 30.4) p.yaw = BASE + Math.PI * 2 * ease(seg(c, 28.4, 30.4));
    if (c < 2.6) caption('');
    else if (c < 6.4) caption(L('Size', 'Afmetingen'));
    else if (c < 10.6) caption(L('Outer edges of the cradles', 'Buitenkant van de steunen'));
    else if (c < 24.6) caption(L('Which razors fit?', 'Welke scheermessen passen?'));
    else caption('');
    if (cycleOn) { var cyc = Math.floor(time / CYCLE); if (c0 >= CYCLE - 0.4 && lastCyc !== cyc) { lastCyc = cyc; setColor((colorIdx + 1) % COLORS.length); } }
    return p;
  }

  function frame(now) {
    if (stage.dataset.paused === '1') { last = now; requestAnimationFrame(frame); return; }
    var dt = last == null ? 0 : Math.min(0.05, (now - last) / 1000); last = now;
    if (loaded) {
      t += dt;
      var p = pose(t);
      if (!dragging) { idle += dt; if (idle > 2.5) userYaw *= Math.pow(0.15, dt); }
      var sway = reduce ? 0 : 0.05 * Math.sin(t * 0.7);
      turn.rotation.y = p.yaw + sway + userYaw;
      var fk = p.flipK % 1;
      flip.rotation.x = -Math.PI * 2 * fk;
      flip.position.y = MID + FOOT + 36 * Math.sqrt(Math.max(0, Math.sin(Math.PI * fk)));
      if (p.lift !== camLift) { camLift = p.lift; placeCamera(camLift); }
      for (var i = 0; i < razors.length; i++) {
        var rz = razors[i], s = p.show[i], spec = RAZORS[i], rest = restPos(spec.r);
        rz.visible = s !== 0;
        if (!rz.visible) continue;
        var k = s > 0 ? 1 - s : -s;   // 1 = away (above), 0 = resting
        rz.position.set(rest.x, rest.y + 80 * k * k, rest.z - 20 * k * k);
      }
      // drips: three drops fall from under the last razor's head into the tray, each with a small ripple
      var hx = endX(RAZORS[3]) - 1.5, hy = HI.y + SLOPE * (hx - HI.x) - 0.6;
      drops.forEach(function (d, j) {
        var tt = p.drip - j * 1.1;
        if (p.drip < 0 || tt < 0 || tt > 1.2) { d.m.visible = false; d.ring.visible = false; return; }
        var fallT = Math.min(tt / 0.55, 1);
        d.m.visible = fallT < 1; d.m.position.set(hx + j * 1.5, hy - (hy - 3.8) * fallT * fallT, 2 - j * 2);
        d.ring.visible = fallT >= 1; d.ring.position.set(hx + j * 1.5, 3.05, 2 - j * 2);
        var rk = (tt - 0.55) / 0.65; d.ring.scale.setScalar(1 + 5 * rk); d.ring.material.opacity = 0.8 * (1 - rk);
      });
      hlMat.opacity = p.hl;
      var fh = p.feet || 0; footHl.opacity = fh; rubberMat.emissive.setRGB(0.12 * fh, 0.12 * fh, 0.12 * fh);
      updateDims(p.dims);
      updateCallout(p.co, p.coA);
      if (mixK < 1) { mixK = Math.min(1, mixK + dt / 0.8); bodyMat.color.copy(fromC).lerp(toC, ease(mixK)); }
    }
    renderer.render(scene, camera);
    requestAnimationFrame(frame);
  }

  stage.addEventListener('pointerdown', function (e) { dragging = true; dragX = e.clientX; idle = 0; stage.setPointerCapture(e.pointerId); });
  stage.addEventListener('pointermove', function (e) { if (!dragging) return; userYaw += (e.clientX - dragX) * 0.008; dragX = e.clientX; });
  function endDrag() { dragging = false; idle = 0; }
  stage.addEventListener('pointerup', endDrag); stage.addEventListener('pointercancel', endDrag);
  var cycleBtn = document.getElementById('cycle');
  function setCycle(on) { cycleOn = on; if (cycleBtn) { cycleBtn.setAttribute('aria-pressed', String(on)); cycleBtn.textContent = L('Cycle colours: ', 'Kleuren wisselen: ') + (on ? L('on', 'aan') : L('off', 'uit')); } }
  if (cycleBtn) cycleBtn.addEventListener('click', function () { setCycle(!cycleOn); });
  document.querySelectorAll('#swatches button').forEach(function (b) { b.addEventListener('click', function () { setCycle(false); setColor(+b.dataset.c, false); }); });
  var replayBtn = document.getElementById('replay');
  if (replayBtn) replayBtn.addEventListener('click', function () { t = 0; lastCyc = -1; userYaw = 0; });
  var pre = document.querySelector('#swatches button[aria-pressed="true"]');
  if (pre) setColor(+pre.dataset.c, true);
  if (reduce) setCycle(false);
  stage.dwSeek = function (s) { t = s; };
  if (window.ResizeObserver) new ResizeObserver(resize).observe(stage); else window.addEventListener('resize', resize);
  resize();
  requestAnimationFrame(frame);

  // ---------- loading ----------
  function fail(msg) { statusEl.hidden = false; statusEl.textContent = L('The model could not be loaded', 'Het model kon niet worden geladen') + ' (' + String(msg).slice(0, 120) + ').'; }
  function toGLB(json) {
    var uri = json.buffers[0].uri, b64 = uri.slice(uri.indexOf(',') + 1);
    var raw = atob(b64), bin = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) bin[i] = raw.charCodeAt(i);
    delete json.buffers[0].uri;
    var jsonBytes = new TextEncoder().encode(JSON.stringify(json));
    var jsonPad = (4 - jsonBytes.length % 4) % 4, binPad = (4 - bin.length % 4) % 4;
    var jl = jsonBytes.length + jsonPad, bl = bin.length + binPad, total = 12 + 8 + jl + 8 + bl;
    var out = new ArrayBuffer(total), dv = new DataView(out), u8 = new Uint8Array(out);
    dv.setUint32(0, 0x46546C67, true); dv.setUint32(4, 2, true); dv.setUint32(8, total, true);
    dv.setUint32(12, jl, true); dv.setUint32(16, 0x4E4F534A, true);
    u8.set(jsonBytes, 20); for (i = 0; i < jsonPad; i++) u8[20 + jsonBytes.length + i] = 0x20;
    dv.setUint32(20 + jl, bl, true); dv.setUint32(24 + jl, 0x004E4942, true);
    u8.set(bin, 28 + jl);
    return out;
  }
  function withUtils(cb) {
    if (THREE.BufferGeometryUtils) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/three@0.147.0/examples/js/utils/BufferGeometryUtils.js';
    s.onload = cb; s.onerror = cb; document.head.appendChild(s);
  }
  var src = stage.getAttribute('data-model'), asJson = /\.json(\?|$)/.test(src);
  var xhr = new XMLHttpRequest();
  xhr.open('GET', src); xhr.responseType = asJson ? 'text' : 'arraybuffer'; xhr.timeout = 60000;
  xhr.onprogress = function (ev) { if (ev.total) statusEl.textContent = L('Loading model\u2026 ', 'Model laden\u2026 ') + Math.round(ev.loaded / ev.total * 100) + '%'; };
  xhr.onerror = function () { fail('network error'); };
  xhr.ontimeout = function () { fail('timed out'); };
  xhr.onload = function () {
    if (xhr.status && xhr.status !== 200) { fail('HTTP ' + xhr.status); return; }
    var glb;
    try { glb = asJson ? toGLB(JSON.parse(xhr.responseText)) : xhr.response; } catch (e) { fail('could not read the file'); return; }
    withUtils(function () {
      new THREE.GLTFLoader().parse(glb, '', function (gltf) {
        gltf.scene.traverse(function (o) {
          if (!o.isMesh) return;
          var name = o.name || (o.parent && o.parent.name) || '';
          if (/Logo/.test(name)) { o.geometry = o.geometry.index ? o.geometry.toNonIndexed() : o.geometry; o.geometry.computeVertexNormals(); o.material = logoMat; }
          else { o.geometry = smooth(o.geometry); o.material = bodyMat; o.castShadow = true; o.receiveShadow = true; }
        });
        model.add(gltf.scene);
        RAZORS.forEach(function (spec) {
          var rz = makeRazor(spec); rz.rotation.z = ROT; rz.visible = false; model.add(rz); razors.push(rz);
        });
        statusEl.hidden = true; loaded = true; model.visible = true;
      }, function (e) { fail(e && e.message ? e.message : 'parse error'); });
    });
  };
  xhr.send();
})();
